<template>
    <div class="wrapper">
        <TitleModules title="公司简介" english="INTRODUCE" type="blue"></TitleModules>
        <div class="content">
            <div class="text-section">上海勤联物联网有限公司简称勤联科技，英文名Shanghai Qlian I.O.T Co.Ltd ，注册地徐汇区，注册资本1176万元，是上海市高新技术企业拥有ICP、人力资源许可证、互联网食品销售许可证等证书，累计服务超过1000万会员！业务涵盖APP、微信端和支付宝端。</div>
            <!-- <div class="text-section">截止目前拥有37个软件著作权、15个商标，2020年通过企业知识产权管理体系认证（GB/T29490-2013）,是一家专注研发创新和注重知识产权的公司！同时主动协助客户获得了数十个软件著作权！</div> -->
            <!-- <img class="partners-img" data-src="../../static/img/aptitude-img.png" alt=""> -->
        </div>
        <div class="channels-box">
            <img class="channels-img" data-src="../../static/img/channels-img.jpg" alt="">
            <div class="channels-content">
                <TitleModules title="全渠道研发&运营能力" english="OMNI CHANNEL" type="white"></TitleModules>
                <div class="channels-text">
                    公司业务包含安卓APP（小米、华为、腾讯应用宝、OPPO、VIVO、360等十几家渠道）、苹果IOS APP、微信、支付宝、UC浏览器APP/夸克APP等渠道累计服务尽<span>2000万网民</span>，日活<span>30万用户</span>左右
                </div>
            </div>

        </div>
        <TitleModules title="赋能数字化" english="ENABLING DIGITIZATION" type="blue"></TitleModules>
        <div class="content-num-box">
            <div class="content-num-left">
                <img loading="lazy" data-src="../../static/img/process-img.png" alt="">
            </div>
            <div class="content-num-right">
                <div class="content-num-right-question">什么是数字化转型</div>
                <div class="content-num-right-answer">数字化转型：DT（DIGITAL-TRANSFORMATION），利用数字化技术进行第2版的TRANSFORMATION，帮助线下商户和实体门店在支付经营过程中，充分利用微信和支付宝内流量和营销能力，提升商户的营销效率，从而带动商户GMV的增长。</div>
            </div>
        </div>
        <div class="partners-box">
            <div class="partners-title">
                <TitleModules title="合作伙伴" english="COOPERATIVE PARTNER" type="blue"></TitleModules>
            </div>
            <img class="partners-img" data-src="../../static/img/partners.png" alt="">
        </div>

        <TitleModules title="勤联科技创始人" english="FOUNDER" type="blue"></TitleModules>
      <div class="teamText">{{teamText}}</div>
      <div class="teamBox">
        <!-- <img class="team" :data-src="team" alt=""> -->
      </div>
<!--        <div class="founders-img">-->
<!--          <img style="width: 1642px" :data-src="team" alt="">-->
<!--            <div class="founder-item" v-for="(item,index) in founders" :key="index">-->
<!--                <img :data-src="item.img" alt="">-->
<!--                <div class="founder-info">{{item.text}}</div>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>
<script>
import TitleModules from '../components/Title-modules'
export default {
    name: 'index',
    components: {
        TitleModules
    },
    data(){
        return {
          team: require('../../static/team.png'),
          teamText: '公司创始团队毕业于清华大学、中欧国际工商学院等名校，拥有成功连续创业经验，愿景是将运动健康和社交电商结合希望看到更多的客户生活更健康美好！',
            founders: [
                // {
                //     img: require('../../static/img/founder1.png'),
                //     text: '周俊，本科毕业于郑州大学金融数学专业，2017年毕业于浙江大学金融学硕士，毕业后一直在VC创投任职，担任杭州万豪投资管理有限公司投资总监，成功投资IT互联网、新零售领域等多家企业并退出，目前担任上海勤联物联网有限公司董事长'
                // },
                // {
                //     img: require('../../static/img/founder2.png'),
                //     text: '朱慧觉，中国民主建国会会员，2017年毕业于中欧国际工商学院工商管理硕士，清华大学经济管理学院研究生在读，连续创业者，2005年进入互联网行业从事技术研发、管理和产品运营工作，目前担任上海勤联物联网有限公司总经理 '
                // },
                // {
                //     img: require('../../static/img/founder3.png'),
                //     text: '高玮琨，中国民主建国会，毕业于华东师范大学计算机本科，是互联网连续创业者，沉浸互联网行业15年，参与过多个千万级用户量级的移动APP项目研发和运营！目前担任上海勤联物联网有限公司总裁'
                // }
            ]
        }
    },
    created(){
        localStorage.setItem('path','./')
        localStorage.setItem('index',0)
    },
    mounted(){
        this.handleScroll()
    },
    methods: {
        handleScroll(){
            const images = document.querySelectorAll("img");
            // 传给IntersectionObserver的回调函数
            // 在目标元素能看见时触发一次，目标元素看不见了时再触发一次
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const image = entry.target;
                        const data_src = image.getAttribute("data-src");
                        image.setAttribute("src", data_src);
                        console.log('触发')
                        // 图片被加载后取消观察
                        observer.unobserve(image);
                    }
                });
            });
            images.forEach(image => {
                observer.observe(image);
            });
        }
    }
}
</script>
<style scoped>
@media only screen and (max-width: 1480px) {
    .content{
        width: 1052px;
        margin: 0 auto;
    }
    .text-section{
        text-indent:2em;
        font-size: 21px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #2B2E48;
        line-height: 40px;
    }
    .partners-img{
        width: 100%;
        margin-top: 54px;
    }
    .channels-box{
        width: 100%;
        position: relative;
        margin-top: 80px;
    }
    .channels-img{
        width: 100%;
    }
    .channels-content{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }
    .channels-text{
        width: 1039px;
        font-size: 21px;
        color: #EBEEF5;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 40px;
        position: absolute;
        bottom: 119px;
        left: 50%;
        transform: translateX(-50%);
    }
    .channels-text > span{
        color: #FFFAAA;
        font-size: 24px;
    }
    .content-num-box{
        width: 1052px;
        margin: 0 auto;
        display: flex;
        align-items: center;
    }
    .content-num-left{
        width: 566px;
        margin-right: 80px;
    }
    .content-num-left > img{
        width: 566px;
    }
    .content-num-right-question{
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 40px;
    }
    .content-num-right-answer{
        font-size: 21px;
        line-height: 40px;
        margin-top: 40px;
        word-wrap: break-word;
        word-break: break-all;
    }
    .partners-box{
        width: 100%;
        margin-top: 120px;
        position: relative;
    }
    .partners-title{
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }
    .partners-img{
        width: 100%;
    }
  .teamText{
    width: 72%;
    margin: 0 auto;
    text-align: center;
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 55px;
  }
  .teamBox{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .team{
    width:85%;
    margin-top: 50px;
  }
    .founders-img{
        width: 1052px;
        margin: 1px auto 100px;
        display: flex;
        justify-content: space-between;

    }
    .founder-item{
        width: 340px;
        position: relative;
    }
    .founder-item > img{
        width: 340px;
    }
    .founder-info{
        width: 340px;
        position: absolute;
        box-sizing: border-box;
        padding: 0 17px;
        left: 0;
        bottom: 13px;
        font-size: 17px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 30px;
    }
}

@media only screen and (min-width: 1480px) {
    .content{
        width: 1480px;
        margin: 0 auto;
    }
    .text-section{
        text-indent:2em;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #2B2E48;
        line-height: 56px;
    }
    .partners-img{
        width: 100%;
        margin-top: 70px;
    }
    .channels-box{
        width: 100%;
        position: relative;
        margin-top: 120px;
    }
    .channels-img{
        width: 100%;
    }
    .channels-content{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }
    .channels-text{
        width: 1460px;
        font-size: 30px;
        color: #EBEEF5;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 56px;
        position: absolute;
        bottom: 160px;
        left: 50%;
        transform: translateX(-50%);
    }
    .channels-text > span{
        color: #FFFAAA;
        font-size: 34px;
    }
    .content-num-box{
        width: 1480px;
        margin: 0 auto;
        display: flex;
        align-items: center;
    }
    .content-num-left{
        width: 800px;
        margin-right: 100px;
    }
    .content-num-left > img{
        width: 800px;
    }
    .content-num-right-question{
        font-size: 34px;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 56px;
    }
    .content-num-right-answer{
        font-size: 28px;
        line-height: 56px;
        margin-top: 50px;
        word-wrap: break-word;
        word-break: break-all;
    }
    .partners-box{
        width: 100%;
        margin-top: 120px;
        position: relative;
    }
    .partners-title{
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }
    .partners-img{
        width: 100%;
    }
    .teamText{
      width: 1325px;
      margin: 0 auto;
      text-align: center;
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 55px;
    }
    .teamBox{
      display: flex;
      align-items: center;
      justify-content: center;
    }
  .team{
    width:85%;
    margin-top: 50px;
  }
    .founders-img{
        width: 1540px;
        margin: 100px auto;
      text-align: center;
        /*display: flex;*/
        /*justify-content: space-between;*/

    }
    .founder-item{
        width: 480px;
        position: relative;
    }
    .founder-item > img{
        width: 480px;
    }
    .founder-info{
        width: 480px;
        position: absolute;
        box-sizing: border-box;
        padding: 0 25px;
        left: 0;
        bottom: 20px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 43px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue